import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import washingtonDc__asset from "@/assets/restore/locations/washington-dc.jpg.asset.json";

const cities: StateCity[] = [
  {
    name: "Washington DC",
    address: "1875 I Street, NW, 5th Floor",
    img: washingtonDc__asset.url,
    mapUrl: "https://www.google.com/maps/search/?api=1&query=1875+I+Street+NW+Washington+DC",
    to: "/locations/district-of-columbia/",
  },
];

export const Route = createFileRoute("/locations/district-of-columbia/")({
  head: () => ({
    meta: [
      { title: "Washington DC Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in Washington DC. Book a free personal hair loss consultation at our downtown DC location and learn about our FUE hair transplant procedure.",
      },
      { property: "og:title", content: "Washington DC Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair in Washington DC and book a free consultation to learn about the FUE procedure.",
      },
      {
        property: "og:url",
        content: "https://restorehair.com/locations/district-of-columbia/",
      },
    ],
    links: [
      {
        rel: "canonical",
        href: "https://restorehair.com/locations/district-of-columbia/",
      },
    ],
  }),
  component: () => <StateLocationsHub stateName="Washington DC" cities={cities} />,
});